<template>
  <div>
    <div class="toolbar">
     <button
        v-for="item in statusFilters"
        :key="item.value || 'all'"
        type="button"
        class="status-chip"
        :class="{ active: status === item.value }"
        @click="onStatusFilter(item.value)"
      >
        <span>{{ item.label }}</span>
        <span class="status-chip-count">{{ item.count }}</span>
      </button>
      <el-input v-model="keyword" clearable placeholder="项目名称/电话/地址" style="width:220px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openCreate">新建项目</el-button>
    </div>
    <div class="status-filters">
     
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="{ $index }">{{ (page - 1) * pageSize + $index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="name" label="项目名称" min-width="140" />
      <el-table-column prop="customerPhone" label="联系电话" width="110" />
      <el-table-column prop="address" label="项目地址" min-width="160" show-overflow-tooltip />
      <el-table-column prop="currentStageName" label="当前工序" min-width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span
            class="stage-name-text"
            :class="'stage-' + (row.currentStageStatus || '')"
          >{{ row.currentStageName || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sourceTypeName" label="项目来源" width="110" />
      <el-table-column prop="projectTypeName" label="项目类型" width="100" />
      <el-table-column prop="area" label="面积" width="90" />
      <el-table-column prop="money" label="金额" width="110" />
      <el-table-column prop="houseTypeName" label="房型" width="120" />
      <el-table-column prop="pmName" label="项目经理" width="100" show-overflow-tooltip />
      <el-table-column prop="startDate" label="开工日期" width="100">
        <template slot-scope="{ row }">{{ (row.startDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="88" fixed="right" align="center">
        <template slot-scope="{ row }">
          <span class="status-text" :class="'status-' + (row.status || '')">
            {{ statusLabel(projectStatusMap, row.status) }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="130" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="goDetail(row)">详情</el-button>
          <el-button type="text" @click="openEdit(row)" :disabled="row.status==='COMPLETED'">编辑</el-button>
          <el-button type="text" class="op-danger" @click="onDelete(row)" :disabled="row.status==='COMPLETED'">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="formMode==='create'?'新建项目':'编辑项目'" :visible.sync="formVisible" width="720px" top="5vh">
      <el-form :model="form" label-width="100px">
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="项目名称" required>
              <el-input v-model="form.name" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" required>
              <el-input v-model="form.customerPhone" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="项目地址" required>
              <el-input v-model="form.address" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目来源" required>
              <dict-select-with-add
                v-model="form.sourceTypeId"
                dict-type="SOURCE_TYPE"
                value-field="id"
                add-text="添加来源"
                label-placeholder="如：电话咨询、抖音"
                placeholder="请选择"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目类型" required>
              <dict-select-with-add
                v-model="form.projectTypeId"
                dict-type="PROJECT_TYPE"
                value-field="id"
                add-text="添加类型"
                label-placeholder="如：全包、半包"
                placeholder="请选择"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="装修面积" required>
              <el-input-number v-model="form.area" :min="0.01" :precision="2" :controls="false" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目金额" required>
              <el-input-number v-model="form.money" :min="0" :precision="2" :controls="false" style="width:100%" />
            </el-form-item>
          </el-col>
          <el-col v-if="caps.projectHouseType" :span="12">
            <el-form-item label="房型" :required="formMode==='create'">
              <select-with-nav-add
                v-if="formMode==='create'"
                v-model="form.houseTypeId"
                add-text="添加房型"
                nav-path="/project/house-type"
                placeholder="选择房型"
                @add="goHouseTypeSettings"
              >
                <el-option v-for="h in houseTypes" :key="h.id" :label="h.name" :value="h.id" />
              </select-with-nav-add>
              <el-input v-else :value="form.houseTypeName || '-'" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开工日期" :required="formMode==='create'">
              <el-date-picker
                v-if="formMode==='create'"
                v-model="form.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                style="width:100%"
              />
              <el-input v-else :value="(form.startDate || '').slice(0, 10) || '-'" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="竣工日期">
              <el-date-picker v-model="form.completionDate" type="date" value-format="yyyy-MM-dd" style="width:100%" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目经理" required>
              <select-with-nav-add
                v-model="form.pmUserId"
                add-text="添加成员"
                nav-path="/sys/user"
                placeholder="请选择项目经理"
                @change="ensurePmInMembers"
                @add="goUserManage"
              >
                <el-option
                  v-for="u in pmUsers"
                  :key="u.id"
                  :label="u.nickname || u.username"
                  :value="u.id"
                />
              </select-with-nav-add>
            </el-form-item>
          </el-col>
          <el-col v-if="caps.projectMembers" :span="24">
            <el-form-item label="项目成员" required>
              <select-with-nav-add
                v-model="form.memberUserIds"
                multiple
                add-text="添加成员"
                nav-path="/sys/user"
                placeholder="多选用户/工人/供应商"
                @add="goUserManage"
              >
                <el-option
                  v-for="u in memberUsers"
                  :key="u.id"
                  :label="memberLabel(u)"
                  :value="u.id"
                />
              </select-with-nav-add>
              <div class="member-default-tip">
                设置所有项目默认项目成员，
                <el-button type="text" class="member-default-link" @click="goParamSettings">点击设置</el-button>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input v-model="form.remark" type="textarea" :rows="2" />
            </el-form-item>
          </el-col>
          <el-col v-if="caps.projectBindCustomer" :span="24">
            <el-form-item label="是否绑定客户">
              <el-switch
                v-model="form.needBindCustomer"
                :active-value="1"
                :inactive-value="0"
              />
              <span class="form-hint">开启后，客户需在小程序绑定本项目，之后可以查看项目信息，项目经理方可在 App 中操作</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <el-upload
                action="#"
                :http-request="elUploadHttpRequest"
                :file-list="fileList"
                :on-success="onUploadSuccess"
                :on-remove="onUploadRemove"
                :on-preview="onUploadPreview"
                multiple
              >
                <el-button size="small" type="primary" plain>上传附件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="formVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveForm">
          保存
        </el-button>
      </div>
      </el-dialog>
  </div>
</template>

<script>
import {
  listProjects, createProject, updateProject, deleteProject,
  getProject, listHouseTypes
} from '../../api/project'
import { listUsers, getParamByCode } from '../../api/sys'
import { projectStatusMap, statusLabel } from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import DictSelectWithAdd from '../../components/DictSelectWithAdd.vue'
import SelectWithNavAdd from '../../components/SelectWithNavAdd.vue'
import listPaging from '../../mixins/listPaging'
import { elUploadHttpRequest } from '../../utils/ossUpload'
import { planCapabilities } from '../../utils/plan'
import { mapState } from 'vuex'

export default {
  name: 'ProjectList',
  components: { ListPagination, DictSelectWithAdd, SelectWithNavAdd },
  mixins: [listPaging],
  computed: {
    ...mapState(['user']),
    caps() {
      return planCapabilities(this.user)
    },
    list() {
      if (!this.status) return this.allList
      return (this.allList || []).filter((p) => p.status === this.status)
    },
    statusFilters() {
      const source = this.allList || []
      const countBy = (s) => source.filter((p) => p.status === s).length
      return [
        { value: '', label: '全部', count: source.length },
        { value: 'DRAFT', label: '未开始', count: countBy('DRAFT') },
        { value: 'IN_PROGRESS', label: '进行中', count: countBy('IN_PROGRESS') },
        { value: 'COMPLETED', label: '已竣工', count: countBy('COMPLETED') }
      ]
    }
  },
  data() {
    return {
      projectStatusMap,
      keyword: '',
      status: '',
      allList: [],
      houseTypes: [],
      pmUsers: [],
      memberUsers: [],
      loading: false,
      saving: false,
      formVisible: false,
      formMode: 'create',
      form: {},
      fileList: []
    }
  },
  created() {
    if (this.$route.query.status) this.status = this.$route.query.status
    this.loadPmUsers()
    this.load()
  },
  methods: {
    elUploadHttpRequest,
    statusLabel,
    onStatusFilter(value) {
      const next = value || ''
      if (this.status === next) return
      this.status = next
      this.page = 1
    },
    memberLabel(u) {
      if (u.workerId) {
        return u.workerName || u.nickname || u.username || ('用户' + u.id)
      }
      if (u.supplierId) {
        return u.username || u.nickname || ('用户' + u.id)
      }
      return u.nickname || u.username || ('用户' + u.id)
    },
    /** 已停用/已删除的历史成员也要能显示姓名，避免选择框只剩用户 id */
    mergeHistoryMembers(members) {
      const known = new Set(this.memberUsers.map(u => u.id))
      members.forEach(m => {
        if (m.userId && !known.has(m.userId)) {
          this.memberUsers.push({
            id: m.userId,
            username: m.username,
            nickname: m.nickname,
            jobTitleName: m.jobTitleName
          })
        }
      })
    },
    async loadPmUsers() {
      const res = await listUsers({ roleCode: 'PROJECT_MANAGER' })
      this.pmUsers = (res.data || []).filter(u => u.enabled !== 0)
    },
    async loadMeta() {
      const tasks = [
        Promise.resolve({ data: [] }),
        listUsers({ roleCode: 'PROJECT_MANAGER' }),
        listUsers({ includeWorker: true, includeSupplier: true })
      ]
      if (this.caps.projectHouseType) {
        tasks[0] = listHouseTypes({})
      }
      const [ht, pm, users] = await Promise.all(tasks)
      this.houseTypes = ((ht && ht.data) || []).filter(h => h.enabled !== 0)
      this.pmUsers = ((pm && pm.data) || []).filter(u => u.enabled !== 0)
      this.memberUsers = ((users && users.data) || []).filter(u => u.enabled !== 0)
    },
    goParamSettings() {
      this.formVisible = false
      this.$router.push({ path: '/sys/param' })
    },
    goHouseTypeSettings() {
      this.formVisible = false
      this.$router.push({ path: '/project/house-type' })
    },
    goUserManage() {
      this.formVisible = false
      this.$router.push({ path: '/sys/user' })
    },
    async load() {
      this.loading = true
      try {
        const res = await listProjects({ keyword: this.keyword })
        this.allList = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async loadDefaultMembers() {
      try {
        const res = await getParamByCode('Default-Project-Member')
        const raw = ((res.data && res.data.paramValue) || '').trim()
        if (!raw) return []
        const names = raw.split(/[,，]/).map(s => s.trim()).filter(Boolean)
        const ids = []
        names.forEach(name => {
          const u = this.memberUsers.find(x => x.username === name)
          if (u) ids.push(u.id)
        })
        return ids
      } catch (e) {
        return []
      }
    },
    async openCreate() {
      await this.loadMeta()
      const defaultMembers = await this.loadDefaultMembers()
      this.formMode = 'create'
      this.form = {
        houseTypeId: null,
        startDate: '',
        completionDate: '',
        name: '',
        customerPhone: '',
        address: '',
        sourceTypeId: null,
        projectTypeId: null,
        area: undefined,
        money: undefined,
        pmUserId: null,
        memberUserIds: defaultMembers,
        attachmentIds: [],
        remark: '',
        needBindCustomer: 1
      }
      this.fileList = []
      this.formVisible = true
    },
    async openEdit(row) {
      await this.loadMeta()
      const res = await getProject(row.id)
      const d = res.data || {}
      const p = d.project || row
      const members = d.members || []
      const attachments = d.attachments || []
      this.mergeHistoryMembers(members)
      this.formMode = 'edit'
      this.form = {
        id: p.id,
        name: p.name || p.customerName || '',
        customerPhone: p.customerPhone,
        address: p.address,
        sourceTypeId: p.sourceTypeId || null,
        projectTypeId: p.projectTypeId || null,
        area: p.area != null ? Number(p.area) : undefined,
        money: p.money != null ? Number(p.money) : undefined,
        houseTypeId: p.houseTypeId || null,
        houseTypeName: p.houseTypeName || '',
        startDate: p.startDate ? String(p.startDate).slice(0, 10) : '',
        completionDate: p.completionDate ? String(p.completionDate).slice(0, 10) : '',
        pmUserId: (d.pmUserIds && d.pmUserIds.length)
          ? d.pmUserIds[0]
          : (p.pmUserId || null),
        memberUserIds: members.map(m => m.userId),
        attachmentIds: attachments.map(a => a.id),
        remark: p.remark,
        needBindCustomer: p.needBindCustomer === 0 ? 0 : 1
      }
      this.fileList = attachments.map(a => ({
        name: a.fileName,
        url: a.url,
        response: { data: a },
        uid: a.id
      }))
      this.formVisible = true
    },
    onUploadSuccess(res, file, fileList) {
      if (!res || res.code !== 200 || !res.data) {
        this.$message.error((res && res.message) || '上传失败')
        return
      }
      this.fileList = fileList
      this.syncAttachmentIds()
    },
    onUploadRemove(file, fileList) {
      this.fileList = fileList
      this.syncAttachmentIds()
    },
    onUploadPreview(file) {
      const url = (file.response && file.response.data && file.response.data.url)
        || file.url
      if (url && /^https?:\/\//i.test(url)) {
        window.open(url)
        return
      }
      this.$message.warning('暂无预览地址')
    },
    syncAttachmentIds() {
      this.form.attachmentIds = (this.fileList || []).map(f => {
        if (f.response && f.response.data && f.response.data.id) return f.response.data.id
        if (f.uid && typeof f.uid === 'number') return f.uid
        return null
      }).filter(Boolean)
    },
    /** 项目经理必须在项目成员中 */
    ensurePmInMembers() {
      const pmId = this.form.pmUserId
      if (!pmId) return
      const ids = Array.isArray(this.form.memberUserIds) ? this.form.memberUserIds.slice() : []
      if (!ids.includes(pmId)) {
        ids.push(pmId)
        this.$set(this.form, 'memberUserIds', ids)
      }
    },
    validateForm() {
      const f = this.form
      if (!f.name || !f.customerPhone || !f.address) {
        this.$message.warning('请填写项目名称、联系电话与项目地址')
        return false
      }
      if (!f.sourceTypeId || !f.projectTypeId) {
        this.$message.warning('请选择项目来源与项目类型')
        return false
      }
      if (f.area == null || Number(f.area) <= 0) {
        this.$message.warning('请填写装修面积')
        return false
      }
      if (f.money == null || Number(f.money) < 0) {
        this.$message.warning('请填写项目金额')
        return false
      }
      if (this.formMode === 'create' && !f.startDate) {
        this.$message.warning('请选择开工日期')
        return false
      }
      if (this.formMode === 'create' && this.caps.projectHouseType && !f.houseTypeId) {
        this.$message.warning('请选择房型')
        return false
      }
      if (!f.pmUserId) {
        this.$message.warning('请选择项目经理')
        return false
      }
      if (this.caps.projectMembers && (!f.memberUserIds || !f.memberUserIds.length)) {
        this.$message.warning('请选择项目成员')
        return false
      }
      if (this.caps.projectMembers && f.memberUserIds && !f.memberUserIds.includes(f.pmUserId)) {
        this.$message.warning('项目经理须包含在项目成员中')
        return false
      }
      if (this.caps.projectMembers) {
        this.ensurePmInMembers()
      }
      return true
    },
    async saveForm() {
      if (!this.validateForm()) return
      if (this.caps.projectMembers) {
        this.ensurePmInMembers()
      }
      this.syncAttachmentIds()
      const payload = {
        ...this.form,
        pmUserId: this.form.pmUserId || null,
        pmUserIds: this.form.pmUserId ? [this.form.pmUserId] : []
      }
      this.saving = true
      try {
        if (this.formMode === 'create') {
          await createProject(payload)
          this.$message.success(this.caps.projectHouseType ? '项目已创建，计划已生成' : '项目已创建')
        } else {
          await updateProject(this.form.id, payload)
          this.$message.success('已保存')
        }
        this.formVisible = false
        this.load()
      } finally {
        this.saving = false
      }
    },
    goDetail(row) {
      this.$router.push({
        path: '/project/detail',
        query: { id: String(row.id) }
      })
    },
    goStages(row) {
      this.$router.push({
        path: '/project/stages',
        query: { projectId: String(row.id) }
      })
    },
    onDelete(row) {
      const label = row.name || row.customerName || ''
      this.$confirm(`确认删除项目「${label}」？`, '提示', { type: 'warning' })
        .then(async () => {
          await deleteProject(row.id)
          this.$message.success('已删除')
          this.load()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.status-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: -4px 0 12px;
}
.status-chip {
  appearance: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #64748b;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 13px;
  line-height: 1.2;
  cursor: pointer;
}
.status-chip-count {
  color: #94a3b8;
  font-variant-numeric: tabular-nums;
}
.status-chip:hover {
  border-color: #93c5fd;
  color: #2563eb;
}
.status-chip:hover .status-chip-count {
  color: #60a5fa;
}
.status-chip.active {
  background: #eff6ff;
  border-color: #93c5fd;
  color: #1d4ed8;
  font-weight: 600;
}
.status-chip.active .status-chip-count {
  color: #3b82f6;
}
.status-text {
  font-size: 13px;
  font-weight: 400;
}
.status-text.status-DRAFT {
  color: #94a3b8;
}
.status-text.status-IN_PROGRESS {
  color: #e6a23c; /* 与项目详情当前节点「进行中」el-tag warning 一致 */
}
.status-text.status-COMPLETED {
  color: #047857;
}
.stage-name-text {
  font-size: 13px;
  font-weight: 400;
}
.stage-name-text.stage-DOING {
  color: #e6a23c; /* 与项目计划工序状态「进行中」一致 */
}
.stage-name-text.stage-DONE {
  color: #67c23a; /* 与项目计划工序状态「已完成」一致 */
}
.stage-name-text.stage-PENDING {
  color: #909399;
}
.form-hint { margin-left: 12px; color: #909399; font-size: 12px; }
.member-default-tip {
  margin-top: 6px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}
.member-default-link {
  padding: 0;
  font-size: 12px;
}
</style>
